import React, { useState } from 'react';
import { providerInitials, providerColor } from '../../utils/provider';

interface ProviderBadgeProps {
  name: string;
  logoUrl: string;
  size?: number;
}

// Shows the provider logo, falling back to a deterministic letter-avatar
// when no URL is set or the image fails to load.
export default function ProviderBadge({ name, logoUrl, size = 32 }: ProviderBadgeProps) {
  const [failed, setFailed] = useState(false);
  React.useEffect(() => setFailed(false), [logoUrl]);
  const showImg = logoUrl.trim() !== '' && !failed;
  if (showImg) {
    return (
      <img
        src={logoUrl}
        alt={name || 'provider logo'}
        width={size}
        height={size}
        className="rounded-full object-cover bg-gray-800"
        onError={() => setFailed(true)}
      />
    );
  }
  return (
    <span
      className="inline-flex items-center justify-center rounded-full font-semibold text-white"
      style={{ width: size, height: size, backgroundColor: providerColor(name), fontSize: size * 0.4 }}
      aria-label={name || 'provider'}
    >
      {providerInitials(name)}
    </span>
  );
}
